// @flow
import type { Route } from './types';

/**
 * Which pages are full-page react. Ideally we pull this from Pages.jsx but that is in roots, and
 * importing it breaks the build.
 */
const ROUTABLE_PAGES = [
  'Profile',
  'Trips',
  'Owners',
  'BrandOwners',
  'ManageShopping',
  'HotelsManagementCenter',
  'HotelsManageListing',
  'SafetyManagementCenter',
  'FavoriteReviewManagement',
  'OwnerVerification',
  'ViewAchAuthorization',
  'Starter_Packages',
];

/**
 * @return true if the given route is an SPA page
 */
export const isRoutable = (route: Route, routablePages: string[] = ROUTABLE_PAGES) =>
  routablePages.includes(route.page);

/**
 * @param from - the current route
 * @param to - the destination route
 * @param routablePages - for testing
 * @return true if we can navigate from the current page to the destination without a full reload
 */
const canNavigate = (from: Route, to: Route, routablePages: string[] = ROUTABLE_PAGES) => {
  if (from.page === to.page) {
    return true;
  }

  return isRoutable(from, routablePages) && isRoutable(to, routablePages);
};

export default canNavigate;
